import type { Sort } from '@carboncopyco/types';

export enum StatusType {
  true = 'Active',
  false = 'Inactive',
}

export enum ActivityType {
  presented = 'Presented',
  visits = 'Visited',
}

export type UrlState = {
  sort?: Sort;
  creators?: string;
  companies?: string;
  sources?: string;
  sourceShareIds?: string;
  sourcePresentationIds?: string;
  activityType?: keyof typeof ActivityType;
  query?: string;
  active?: keyof typeof StatusType;
  links?: string;
  presenters?: string;
  opportunities?: string;
  tab?: 'presentations' | 'visits';
};
